import { useCurrency, useCurrencySetter } from '../context/CurrencyContext';
import './CurrencyToggle.css';

const IconDollar = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const IconEuro = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M4 10h12" />
    <path d="M4 14h9" />
    <path d="M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2" />
  </svg>
);

export default function CurrencyToggle() {
  const currency = useCurrency();
  const setCurrency = useCurrencySetter();

  return (
    <div className="currency-toggle">
      <button
        type="button"
        className={`currency-toggle-btn ${currency === 'usd' ? 'active' : ''}`}
        onClick={() => setCurrency('usd')}
        aria-pressed={currency === 'usd'}
        aria-label="Show prices in USD"
      >
        <span className="currency-toggle-icon"><IconDollar /></span>
        USD
      </button>
      <button
        type="button"
        className={`currency-toggle-btn ${currency === 'eur' ? 'active' : ''}`}
        onClick={() => setCurrency('eur')}
        aria-pressed={currency === 'eur'}
        aria-label="Show prices in EUR"
      >
        <span className="currency-toggle-icon"><IconEuro /></span>
        EUR
      </button>
    </div>
  );
}
